import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';

@Component({
	selector: '[custom-toast-component]',
	styleUrls: [`./custom-toast.component.scss`],
	templateUrl: `./custom-toast.component.html`,
	animations: [
		trigger('flyInOut', [
			state('void', style({ opacity: 0, transform: 'translateX(340px)' })),
			state('inactive', style({ opacity: 0, transform: 'translateX(340px)' })),
			state('active', style({ opacity: 1, transform: 'translateX(0)' })),
			transition('void => active, inactive => active', animate('500ms ease-out', keyframes([
				style({ transform: 'translateX(340px)', opacity: 0, offset: 0 }),
				style({ transform: 'translateX(-20px)', opacity: 1, offset: 0.7 }),
				style({ transform: 'translateX(0)', opacity: 1, offset: 1 })
			]))),
			transition('active => removed', animate('500ms ease-in', keyframes([
				style({ transform: 'translateX(-20px)', opacity: 1, offset: 0.2 }),
				style({ transform: 'translateX(340px)', opacity: 0, offset: 1 })
			])))
		]),
	],
	preserveWhitespaces: false,
	standalone: true,
	imports: [CommonModule]
})
export class CustomToastComponent extends Toast {
	// used for demo purposes
	undoString = 'undo';
	
	// constructor is only necessary when not using AoT
	constructor(
		toastrService: ToastrService,
		toastPackage: ToastPackage,
	) {
		super(toastrService, toastPackage);
	}
	
	action(event: Event) {
		event.stopPropagation();
		this.undoString = 'undid';
		this.toastPackage.triggerAction();
		return false;
	}

	isArray(message: any) {
		if(Array.isArray(message)) {
			return true;
		} else {
			return false;
		}
	}
}